// extracted by mini-css-extract-plugin
export var center = "_4y-2";
export var clickableRow = "_4y-5";
export var expandedRow = "_4y-7";
export var hoverable = "_4y-4";
export var left = "_4y-1";
export var right = "_4y-3";
export var row = "_4y-0";
export var selectedRow = "_4y-6";
export var summaryRow = "_4y-8";